// @flow
import * as React from 'react';
import classNames from 'classnames';

import styles from './PerItem.module.scss';;


type Props = {
  children: React.Node,
  className?: string,
}

const PerItem = ({ children, className }: Props) => (
  <div className={classNames(styles.root, className)}>{children}</div>
);

export default PerItem;
